import { signedDelete, signedGet, signedPost } from "./signedRequest";

export async function createPaidVideoRecord({
  objectKey,
  priceCents,
  previewEnabled,
  caption,
}) {
  const response = await signedPost(
    "/api/v1/profiles/me/paid-videos",
    {
      objectKey,
      priceCents,
      previewEnabled,
      caption,
    }
  );

  return (
    response?.data?.video ||
    response?.data ||
    null
  );
}

export async function fetchOwnPaidVideos() {
  const response = await signedGet(
    "/api/v1/profiles/me/paid-videos"
  );

  return Array.isArray(response?.data?.items)
    ? response.data.items
    : [];
}


export async function deletePaidVideoRecord(videoId) {
  const response = await signedDelete(
    `/api/v1/profiles/me/paid-videos/${encodeURIComponent(videoId)}`
  );

  return response?.data || null;
}
